<template>
    <div class="paymentInfo m-b-20">
        <titles name="交费信息"></titles>
        <div class="content" v-for="(el, index) in item.PayVO" :key="index">
            <p class="m-b-27">交费日期：<span>{{el.payDate}}</span></p>
            <p>交费金额：<span>¥{{el.payMoney}}</span></p>
        </div>
        <div class="total">
            <p>总计：<span>¥{{sum}}</span> </p>
        </div>
    </div>
</template>
<script>
import titles from '@/components/titiles.vue';
export default {
    components:{
        titles,
    },
    props: {
        item: {
        type: Object,
        default: {}
        },
    },
    created(){
        this.calculation();
    },
    data(){
        return {
            sum: 0,
        }
    },
    methods:{
        calculation(){
            this.sum = 0;
            this.item.pays.forEach(el => {
                this.sum += el.payMoney;
            });
        }
    }
}
</script>
<style lang="scss" scoped>
.paymentInfo{
    background: $ffff;
    .content{
        margin-right: 20px;
        font-size:24px;
        color: $color-51;
        padding: 15px 0 17px 0;
        border-bottom: 1px solid rgba(230,230,230,1);
        p{
            margin-left: 56px;
        }
    }
    .total{
        padding: 25px 37px 17px 0 ;
        
        p{
            font-size:24px;
            color: $color-51;  
            text-align: right; 
            span{
                color: $color-36;
            }    
        }
    }
}
</style>

